import { Button, Popover } from '@libs/ui/ds'
import type { FC, ForwardedRef } from 'react'

import type { DateRangeTargetButtonProps } from './DateRangeTargetButton.types'

export const DateRangeTargetButton: FC<DateRangeTargetButtonProps> = ({
  disabled,
  leftIcon,
  rightIcon,
  ref,
  children,
  ...otherProps
}) => {
  return (
    <Popover.Target>
      <Button
        {...otherProps}
        data-testid={otherProps['data-testid'] || 'custom-target-button'}
        ref={ref as ForwardedRef<HTMLButtonElement>}
        leftIcon={leftIcon}
        rightIcon={rightIcon}
        intent='neutral-dark'
        variant='secondary'
        disabled={disabled}
      >
        {children}
      </Button>
    </Popover.Target>
  )
}
